import { render, staticRenderFns } from "./customerIndex2.vue?vue&type=template&id=54996f95&scoped=true"
import script from "./customerIndex2.vue?vue&type=script&lang=js"
export * from "./customerIndex2.vue?vue&type=script&lang=js"
import style0 from "./customerIndex2.vue?vue&type=style&index=0&id=54996f95&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54996f95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54996f95')) {
      api.createRecord('54996f95', component.options)
    } else {
      api.reload('54996f95', component.options)
    }
    module.hot.accept("./customerIndex2.vue?vue&type=template&id=54996f95&scoped=true", function () {
      api.rerender('54996f95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/customerIndex2.vue"
export default component.exports